import { Component, OnInit } from '@angular/core';
import { NavToolbarService } from './nav-toolbar.service';

@Component({
  selector: 'nav-toolbar',
  templateUrl: './nav-toolbar.component.html',
  styleUrls: ['./nav-toolbar.component.scss']
})
export class NavToolbarComponent implements OnInit {

  buttons: NavToolbarButton[];
  constructor(private navToolbarService: NavToolbarService) { }

  ngOnInit() {
    this.navToolbarService.buttons.subscribe(x => this.buttons = x);
  }

  isSelected = (button: NavToolbarButton): boolean => {
    return false;
  }

}


export class NavToolbarButton {
  routerLink: string;
  iconClass: string;
  title: string;
}